import { render, staticRenderFns } from "./DataDetail.vue?vue&type=template&id=6e3ff304&scoped=true&"
import script from "./DataDetail.vue?vue&type=script&lang=ts&"
export * from "./DataDetail.vue?vue&type=script&lang=ts&"
import style0 from "./DataDetail.vue?vue&type=style&index=0&id=6e3ff304&scoped=true&lang=css&"
import style1 from "./DataDetail.vue?vue&type=style&index=1&id=6e3ff304&scoped=true&lang=css&"
import style2 from "./DataDetail.vue?vue&type=style&index=2&id=6e3ff304&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3ff304",
  null
  
)

export default component.exports